module.exports = __webpack_public_path__ + "static/media/schlafcoaching.e3d8bad1.jpg";